export var DEFAULT_TOOLTIP_I18N = {
    srInteractiveHelperText: 'Press tab to access controls.',
};
